import React, { useEffect, useState, useCallback, forwardRef, useImperativeHandle } from 'react';
import axios from 'axios';
import debounce from 'lodash/debounce';
import config from '../config';

const CobraOpenEnrollment = forwardRef(({ caseId, renewalCase, isDisableForUsers, onError = () => { } }, ref) => {
    const fetchUrl = `${config.API_URL}/CobraOpenEnrollmentManagements/ByCaseId/${caseId}`;
    const updateUrl = `${config.API_URL}/CobraOpenEnrollmentManagements`;

    const [enrollmentMethod, setEnrollmentMethod] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});

    useEffect(() => {
        fetchEnrollmentMethod();
    }, [caseId]);

    const fetchEnrollmentMethod = async () => {
        try {
            const response = await axios.get(fetchUrl);
            setEnrollmentMethod(response.data || null);
        } catch (error) {
            setError('Error fetching plans.');
            onError(error);
        } finally {
            setLoading(false);
        }
    };

    const debouncedUpdate = useCallback(
        debounce(async (field, value) => {
            try {
                const patchData = [{ op: 'replace', path: `/${field}`, value }];
                await axios.patch(`${updateUrl}/${enrollmentMethod.id}`, patchData);
            } catch (error) {
                console.error('Error updating field:', error);
                onError(error);
            }
        }, 500),
        [updateUrl, enrollmentMethod, onError]
    );

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEnrollmentMethod(prevInfo => {
            const updatedInfo = { ...prevInfo, [name]: value };
            debouncedUpdate(name, value);
            return updatedInfo;
        });
    };

    //const isDisabled = renewalCase?.cobraSubmissionStatus === 'Submitted' || isDisableForUsers;
    const isDisabled = isDisableForUsers;

    const validateAll = () => {
        let errors = {};

        
        if (enrollmentMethod?.openEnrollmentMethod === "ParticipantEnrollOnline") {
            const noOfDays = enrollmentMethod?.noOfDaysOffered;
            if (!noOfDays) {
                errors.noOfDays = 'No Days field is required.';
            }

            
        }

        
        

        setValidationErrors(errors);

        // Return true if no errors
        return Object.keys(errors).length === 0;
    };

    // Expose methods or properties via ref
    useImperativeHandle(ref, () => ({
        validateAll,
    }));

    if (loading) return <p>Loading...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="col-lg-12 mb-3">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title mb-3">
                        COBRA Open Enrollment Management
                    </h5>

                    <div className="d-flex mb-2">
                        <div className="form-check-inline">
                            <label>Open enrollment method: </label>
                        </div>
                        <div className="form-check-inline">
                            <input
                                type="radio"
                                className="emp-form-check-input"
                                value="ParticipantEnrollOnline"
                                id="ClarityAdminister"
                                name="openEnrollmentMethod"
                                checked={enrollmentMethod?.openEnrollmentMethod === "ParticipantEnrollOnline"}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                            />
                            <label htmlFor="ClarityAdminister">Participant will enroll online with Clarity</label>
                        </div>
                        <div className="form-check-inline">
                            <input
                                type="radio"
                                className="emp-form-check-input"
                                id="BrokerClientAdminister"
                                name="openEnrollmentMethod"
                                value="Broker/Client will manage Open Enrollment"
                                checked={enrollmentMethod?.openEnrollmentMethod === "Broker/Client will manage Open Enrollment"}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                            />
                            <label htmlFor="BrokerClientAdminister">Broker/Client will manage open enrollment</label>
                        </div>
                        <div className="form-check-inline">
                            <input
                                type="radio"
                                className="emp-form-check-input"
                                id="NoOpenEnrollment"
                                name="openEnrollmentMethod"
                                value="No Open Enrollment"
                                checked={enrollmentMethod?.openEnrollmentMethod === "No Open Enrollment"}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                            />
                            <label htmlFor="NoOpenEnrollment">No open enrollment (no active members)</label>
                        </div>
                    </div>

                    {enrollmentMethod?.openEnrollmentMethod === "ParticipantEnrollOnline" && (
                        <div>
                            <div className="row open_enrollment mb-2">
                                <div className="col-lg-5">
                                    <div className="input-group">
                                        How many days are you offering open enrollment to active employees?
                                    </div>
                                </div>
                                <div className="col-lg-1">
                                    <input
                                        placeholder="Days"
                                        className="form-control"
                                        name="noOfDaysOffered"
                                        type="text"
                                        value={enrollmentMethod?.noOfDaysOffered}
                                        onChange={handleInputChange}
                                        disabled={isDisabled}
                                    />
                                    {validationErrors.noOfDays && (
                                        <div className="invalid-feedback d-block">
                                            {validationErrors.noOfDays}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="d-flex mb-2 open_enrollment">
                                <em style={{ color: 'rgb(255, 99, 71)' }}>Once your renewal is submitted, we will create an open enrollment period beginning in the next 10 business days that matches the length of your active employees' OE.</em>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
});

export default CobraOpenEnrollment;
